/** Legacy combined row label (older seeds); also see Others (FINES) in characterization examples */
const CONFRONTATION_AGGREGATE_PARENT_CATEGORY = "Others + under 40 cm + fines";

const CONFRONTATION_FINES_PARENT_CATEGORY = "Others (FINES)";

const PARENT_CATEGORY_TO_I18N_KEY = {
  "paper / cardboard": "parent_category_cardboard",
  cardboard: "parent_category_cardboard",
  cardboards: "parent_category_cardboard",
  metal: "metal_plural",
  metals: "metal_plural",
  plastic: "plastic_plural",
  plastics: "plastic_plural",
  mineral: "mineral_plural",
  minerals: "mineral_plural",
  "mineral fractions": "mineral_plural",
  biowaste: "biowaste",
  biodéchets: "biowaste",
  textiles: "textile_plural",
  textile: "textile_plural",
  others: "Autre + FINES",
  autres: "Autre + FINES",
  other: "Autre + FINES",
  "others (fines)": "Others (fines)",
  "autres (fines)": "Others (fines)",
  "others + under 40 cm + fines": "Others + under 40 cm + fines",
  "autres + inférieur à 40 cm + fines": "Others + under 40 cm + fines",
  glass: "glass",
  wood: "wood",
  plaster: "plaster",
};

const AGGREGATE_LABELS = new Set([
  CONFRONTATION_AGGREGATE_PARENT_CATEGORY.trim().toLowerCase(),
  "autres + inférieur à 40 cm + fines",
  CONFRONTATION_FINES_PARENT_CATEGORY.trim().toLowerCase(),
  "others + under 40 cm + fines",
  "others (fines)",
  "autres (fines)",
]);

const toIdString = (doc) => {
  const raw = doc?._id ?? doc?.id;
  if (raw == null || raw === "") return null;
  return typeof raw === "object" && raw !== null && "$oid" in raw
    ? String(raw.$oid)
    : String(raw);
};

/**
 * Maps API confrontation document (populate wasteCategory, wasteProducerClient).
 * Backend: GET confrontation/getConfrontations | GET confrontation/getOne/:id → { confrontation }.
 */
export const mapApiDocumentToListRow = (doc) => {
  if (!doc) return null;
  const id = toIdString(doc);
  if (!id) return null;

  const cat = doc.wasteCategory;
  const labelParts = [cat?.label].filter(Boolean);
  const confrontationLabel =
    labelParts.length > 0
      ? labelParts.join(" – ")
      : cat?.label || cat?.value || "—";

  return {
    id,
    confrontationLabel,
    characterizationDate: doc.characterizationDate,
    confrontationDate: doc.createdAt,
    totalWeight: doc.characterizationWeightKg,
    flow: cat?.label || cat?.value || "—",
    wmae: doc.wmae,
  };
};

export const isConfrontationAggregateParentRow = (label) => {
  if (!label) return false;
  return AGGREGATE_LABELS.has(String(label).trim().toLowerCase());
};

const normalizeConfrontationParentCategory = (label) => {
  if (label == null) return "";
  return String(label).trim().toLowerCase();
};

export const formatConfrontationParentCategoryLabel = (label, t) => {
  if (!label) return "—";

  const capitalizeLeading = (text) =>
    String(text ?? "").replace(/^(\s*)([a-zà-ÿ])/i, (match, spaces, ch) => {
      return `${spaces}${String(ch).toUpperCase()}`;
    });

  const normalized = normalizeConfrontationParentCategory(label);
  const i18nKey = PARENT_CATEGORY_TO_I18N_KEY[normalized];
  if (i18nKey) return capitalizeLeading(t(i18nKey));

  return capitalizeLeading(String(label).trim());
};

export const buildDetailSectionTitle = (
  t,
  listRow,
  characterizationDateISO,
) => {
  const dateStr =
    characterizationDateISO != null
      ? new Date(characterizationDateISO).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "";
  if (listRow?.confrontationLabel && dateStr) {
    return `${listRow.confrontationLabel} - ${dateStr}`;
  }
  if (listRow?.confrontationLabel) return listRow.confrontationLabel;
  return t("Confrontations");
};
